import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PatchAdminStaffBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Patches an admin staff member and invalidates relevant caches. */
export function usePatchAdminStaff() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...body }: PatchAdminStaffBody & { id: string }) => {
      const response = await api.patch('/admin/staff/:id', { params: { id }, body })
      if (!response.success) throw new Error(response.error.message)
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'staff'] })
      queryClient.invalidateQueries({ queryKey: ['staff'] })
      queryClient.invalidateQueries({ queryKey: ['staff-esignature', variables.id] })
    },
  })
}
